
export enum Roles {
    ADMIN = 'ADMIN',
    GUIDE = 'GUIDE',
    COORDINATOR = 'COORDINATOR',
    LICENCE = 'LICENCE',
    READ_ONLY = 'READ_ONLY'
}
